import { render, staticRenderFns } from "./AkReadOnlyLink.vue?vue&type=template&id=78f3d358&"
import script from "./AkReadOnlyLink.vue?vue&type=script&lang=js&"
export * from "./AkReadOnlyLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/htdocs/wisseloord/src/vue-apps/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78f3d358')) {
      api.createRecord('78f3d358', component.options)
    } else {
      api.reload('78f3d358', component.options)
    }
    module.hot.accept("./AkReadOnlyLink.vue?vue&type=template&id=78f3d358&", function () {
      api.rerender('78f3d358', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "widgets/AkReadOnlyLink.vue"
export default component.exports